import LightningDrawOnMap from "./LightningDrawOnMap";

export default LightningDrawOnMap;